import $ from 'jquery';

const config = {
  buildInfo: process.env['k2-iko'],
  desktop: true,
  showImages: false,
};

config.init = () => {
  // overkill
  config.$el = {
    window: $(window),
    document: $(document),
    html: $(document.documentElement),
    body: $(document.body),
  };
};

export default config;



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/config.js